import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { unwrap } from '@/lib/result';
import { useSessionStore } from '@/stores/session.store';

import { certificationsRepository } from '../api/certifications.repository';

export const certificationKeys = {
  all: ['certifications'] as const,
  forFreelancer: (id: string) => [...certificationKeys.all, 'freelancer', id] as const,
};

export function useCertificationsFor(freelancerId: string) {
  return useQuery({
    queryKey: certificationKeys.forFreelancer(freelancerId),
    queryFn: () => unwrap(certificationsRepository.listForFreelancer(freelancerId)),
    enabled: Boolean(freelancerId),
  });
}

export function useCertify() {
  const queryClient = useQueryClient();
  const userId = useSessionStore((s) => s.userId);
  return useMutation({
    mutationFn: (vars: { freelancerId: string; note: string | null }) =>
      unwrap(certificationsRepository.create(vars.freelancerId, userId as string, vars.note)),
    onSuccess: (_data, vars) => {
      void queryClient.invalidateQueries({
        queryKey: certificationKeys.forFreelancer(vars.freelancerId),
      });
    },
  });
}
